// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__3kADG","fade-in":"styles_fade-in__Idd9O"};